<template>
  <div class="w-100 flex-grow-1 layout-page">
    <div v-if="message && message.switch">
      <v-alert type="info" variant="tonal" color="warning" class="pa-2 w-100">
        <div class="head-alert" v-html="message.message" />
      </v-alert>
      <v-tooltip v-if="message.message" activator="parent" location="top" class="custom-tooltip">
        <div v-html="message.message" />
      </v-tooltip>
    </div>
    <v-layout class="layout">
      <nav-bar
        :key="countPoints"
        :tabs="tabs"
        :is-show-user-info="isShowUserInfo"
        :count="countPoints"
      />
      <div class="main-container w-100">
        <v-main :class="['main content', hasFilters && 'main-has-filters']">
          <router-view :key="route.fullPath" />
          <Footer v-if="showFooter" />
        </v-main>
      </div>
    </v-layout>
    <div id="wrgsv"></div>
  </div>
</template>

<script>
export default {
  name: 'DefaultLayout',
}
</script>
<script setup>
import Footer from '@/components/AppFooter.vue'
import { computed, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import NavBar from '@/components/NavBar.vue'
import { useRoute } from 'vue-router'
import { ADMIN, MANAGER, MONITOR_CONTENT, USER, MONITOR, EXPERT } from '@/enums/roles'
import TaskIcon from '@/components/Icons/TaskIcon.vue'
import ArchiveIcon from '@/components/Icons/ArchiveIcon.vue'
import CompetitionsIcon from '@/components/Icons/CompetitionsIcon.vue'
import UsersIcon from '@/components/Icons/UsersIcon.vue'
import { api } from '@/api/Api'
import DiagnosticsIcon from '@/components/Icons/DiagnosticsIcon.vue'
import ProjectIcon from '@/components/Icons/ProjectIcon.vue'
import ServiceIcon from '@/components/Icons/ServiceIcon.vue'
import { useWidget } from '@/composables/useWidget'

const store = useStore()
const route = useRoute()

useWidget()

const message = ref()

const hasFilters = computed(
  () =>
    route.name === 'programs-list' ||
    route.name === 'tasks-list' ||
    route.name === 'programs-view-data' ||
    route.name === 'usersList' ||
    route.name === 'diagnostics-list' ||
    route.name === 'tasks-list-archive' ||
    route.name === 'tasks-list-archive' ||
    'tasks-archive-list',
)
const showFooter = computed(() => !route.meta.hideFooter)
const isShowUserInfo = computed(
  () => route.name !== 'create-project-by-code-1c' && route.name !== 'task-by-id',
)
const roles = computed(() => store.getters['user/currentRoles'])

const countPoints = ref(0)

const tabsMonitor = [
  {
    sort: 2,
    title: 'Проекты',
    to: '/projects',
    component: ProjectIcon,
  },
]

const tabsProgramms = [
  {
    sort: 1,
    title: 'Конкурсы',
    to: '/programs',
    component: CompetitionsIcon,
  },
  ...tabsMonitor,
]

const tabsTasks = [
  {
    sort: 3,
    title: 'Мои задачи',
    to: '/tasks',
    hasCount: true,
    component: TaskIcon,
  },
  {
    sort: 4,
    title: 'Архив',
    to: '/tasks-archive',
    component: ArchiveIcon,
    customActiveLogic: (route) => route.path === '/tasks-archive',
  },
]

const tabsToAdmin = [
  {
    sort: 5,
    title: 'Пользователи и роли',
    to: '/users',
    component: UsersIcon,
  },
  {
    sort: 6,
    title: 'Сервисное сообщение',
    to: '/service-message',
    component: ServiceIcon,
  },
]

const tabsDefault = [
  {
    sort: 7,
    title: 'Диагностика ЭП',
    to: '/diagnostics',
    component: DiagnosticsIcon,
  },
]

const tabs = computed(() => {
  let tabs = []
  roles.value?.forEach((role) => {
    if (role === ADMIN) {
      tabs = [...tabs, ...tabsToAdmin]
    }

    if (role === USER) {
      tabs = [...tabs, ...tabsTasks, ...tabsProgramms]
    }

    if (role === MANAGER || role === EXPERT) {
      tabs = [...tabs, ...tabsProgramms, ...tabsTasks]
    }

    if (role === MONITOR || role === MONITOR_CONTENT) {
      tabs = [...tabs, ...tabsMonitor, ...tabsTasks]
    }

    tabs = [...tabs, ...tabsDefault]
  })

  return removeDuplicatesByKey(tabs, 'to')?.sort((a, b) => a.sort - b.sort)
})

const getPointsCount = async () => {
  try {
    await api
      .projects()
      .getActivePointsCount()
      .then((data) => {
        countPoints.value = data?.count
      })
  } catch (err) {
    console.log(err)
  }
}

function removeDuplicatesByKey(arr, key) {
  return arr.filter(
    (item, index, self) => index === self.findIndex((obj) => obj[key] === item[key]),
  )
}

const getMessage = async () => {
  await api
    .user()
    .getServiceMessage()
    .then((response) => {
      message.value = response
    })
}

onMounted(() => {
  getPointsCount()
  getMessage()
})
</script>
<style lang="scss" scoped>
.head-alert {
  font-size: 1rem;
  a,
  span,
  p,
  em,
  strong,
  * {
    font-size: 1rem;
  }
}
</style>
<style lang="scss" scoped>
.head-alert {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  font-size: 1rem;
}
.layout-page {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
}
.main-container {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 1;
  min-height: 100%;

  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}

.layout {
  flex-grow: 1;
}

.main {
  height: auto;
  background: var(--light-background);
}

.content {
  flex: 1 0 auto;
}

.footer {
  flex: 0 0 auto;
}

.main-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 100vh;

  .main {
    overflow: auto;
    padding-top: 0;

    &.main-has-filters {
      margin-top: 64px;
    }
  }
}
</style>
<style lang="scss">
.custom-tooltip {
  .v-overlay__content {
    background-color: rgba(0, 0, 0, 0.8) !important;
    opacity: 1 !important;
  }
}
</style>
